import { render } from "./CuadroMandoView.vue?vue&type=template&id=12068f8f&scoped=true"
import script from "./CuadroMandoView.vue?vue&type=script&lang=js"
export * from "./CuadroMandoView.vue?vue&type=script&lang=js"

import "./CuadroMandoView.vue?vue&type=style&index=0&id=12068f8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12068f8f"]])

export default __exports__